import { render, staticRenderFns } from "./submitResume.vue?vue&type=template&id=465bcf19&scoped=true"
import script from "./submitResume.vue?vue&type=script&lang=js"
export * from "./submitResume.vue?vue&type=script&lang=js"
import style0 from "./submitResume.vue?vue&type=style&index=0&id=465bcf19&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465bcf19",
  null
  
)

export default component.exports